//
export const address = {
    addressList: {
        myAddress: {
            zh: '地址列表',
            en: 'My address'
        },
        defaultAddress: {
            zh: '设为默认',
            en: 'default address'
        },
        edit: {
            zh: '编辑',
            en: 'Edit'
        },
        delete: {
            zh: '删除',
            en: 'Delete'
        },
        addNewAddress: {
            zh: '新增地址',
            en: 'Add new address'
        },
        currentlyNoAddress: {
            zh: '当前无地址',
            en: 'Currently no address'
        },
    },
    newAddAddress: {
        deliveryAddress: {
            zh: '送餐地址',
            en: 'Delivery address'
        },
        clickToChoose: {
            zh: '点击选择',
            en: 'Click to choose'
        },
        houseNumber: {
            zh: '门牌号',
            en: 'House number'
        },
        detailAddressEg: {
            zh: '详细地址，例：6号楼6层606室',
            en: 'Detail address,e.g.room 606,6th floor'
        },
        name: {
            zh: '联系人',
            en: 'Name'
        },
        inputName: {
            zh: '请填写收餐人姓名',
            en: 'Input name'
        },
        Mr: {
            zh: '先生',
            en: 'Mr.'
        },
        Ms: {
            zh: '女士',
            en: 'Ms.'
        },
        mobile: {
            zh: '手机号',
            en: 'Mobile'
        },
        inputMobileNumber: {
            zh: '请填写收餐人手机号码',
            en: 'Input mobile number'
        },
        add: {
            zh: '添 加',
            en: 'Add'
        },
        edit: {
            zh: '修 改',
            en: 'Edit'
        },
        saveAndUse: {
            zh: '保存并使用',
            en: 'Save and use'
        },
        modifyAddress: {
            zh: '地址修改',
            en: 'Modify address'
        },
        addressHasBeenDeleted: {
            zh: '亲，该地址已被删除了哦！',
            en: 'Dear, the address has been deleted!'
        },
        selectConfirmAddress: {
            zh: '请到地图上选择或确认地址',
            en: 'Please go to the map to select or confirm the address'
        },
        intelligentAddressFilling: {
            zh: '智能填写地址',
            en: 'Intelligent address filling'
        },
        submit: {
            zh: '提交',
            en: 'Submit'
        },
        addressAutomaticallyIdentify: {
            zh: '粘贴地址信息，可自动识别并填写。如：达小乐，188************，上海市 XXX区 XX街道 XXXXX',
            en: 'Paste address information to identify and fill in automatically. For example: Da Xiaole, 188************, XX Street, XXX District, Shanghai, China'
        },
        selectAddress: {
            zh: '选择地址',
            en: 'Select address'
        },
        enterShippingAddress: {
            zh: '请输入您的收货地址',
            en: 'Please enter your shipping address'
        },
        hotCity: {
            zh: '热门城市',
            en: 'Hot city'
        },
        noAddressFound: {
            zh: '没有搜索到地址',
            en: 'No address found'
        },
    }
}
